import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const Address: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const addressUnit = tRegion("contactData.unit", { defaultValue: ''});
  return (
    <>
      <h3>{tRegion('imprint.contactsList.address.title')}</h3>

      <div className='contacts-block'>
        {tRegion('contactData.companyName')}
        <br />
        {tRegion('contactData.street')}
        <br />
        {addressUnit && <div className='contacts-block'>{addressUnit}</div>}
        {tRegion('contactData.city')}
        <br />
        {tRegion('contactData.country')}
      </div>
    </>
  );
};
